export default __webpack_public_path__ + "static/nonlawyer-362afc7d64bf29e70ca645653acdda83.png";